import api from '..';

export default () => api
  .get(`/tourclient/account/currentUser?_=${Date.now()}`, {
    id: 'current',
    time: 35 * 60000,
    formatting: false,
  })
  .then(data => Promise.resolve({
    isAuth: data.IsAuthenticated,
    user: {
      value: data.MasterAgentUserId === '00000000-0000-0000-0000-000000000000' ? null : data.MasterAgentUserId,
      label: data.FullName,
      login: data.Login === '_GHOST_USER_' ? data.Login : '',
      agency: data.PartnerId,
      name: data.ClaimUserName,
      secret: data.ClientSecret,
    },
    features: data.Features,
    office: {
      value: data?.DepartmentId,
      label: data?.Department,
    },
  }));
